module.exports = __webpack_public_path__ + "static/img/Thomas-Fletcher.69b2ee1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Thomas-Fletcher.jpg
// module id = zcQ9
// module chunks = 0